// extracted by mini-css-extract-plugin
export var boxItems = "_1y-1";
export var boxItemsLg = "_1y-2";
export var button = "_1y-7";
export var buttonHoverless = "_1y-9";
export var buttonLg = "_1y-8";
export var filterGroupBox = "_1y-0";
export var icon = "_1y-3";
export var iconSecondary = "_1y-6";
export var iconWrapper = "_1y-4";
export var iconWrapperLg = "_1y-5";
export var truncatedLabel = "_1y-a";